import { render, staticRenderFns } from "./ImportModalV2.vue?vue&type=template&id=8a58a4ee&scoped=true"
import script from "./ImportModalV2.vue?vue&type=script&lang=js"
export * from "./ImportModalV2.vue?vue&type=script&lang=js"
import style0 from "./ImportModalV2.vue?vue&type=style&index=0&id=8a58a4ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a58a4ee",
  null
  
)

export default component.exports